import {Link, Stack, SxProps, Typography} from '@mui/material';
import {ReactComponent as LockedImage} from '../../images/locked.svg';
import {translations} from '../../i18n/translations';
import {useTranslation} from 'react-i18next';
import {pageWrapperSx} from '../missing-permissions-screen';
import {Language, MarkunreadOutlined, Phone} from '@mui/icons-material';
import {Box} from '@mui/material';

const textSm: SxProps = {
  fontSize: '20px',
  lineHeight: 'normal',
  color: 'var(--dcm-gray)',
  fontWeight: 400,
  textAlign: 'left',
};

const textLinkSm: SxProps = {
  ...textSm,
  fontSize: '16px',
  fontWeight: 500,
  color: 'var(--dcm-blue-base)',
};

type MissingAccessScreenProps = {
  denied?: 'digital_inclusion' | 'care_management';
};

const MissingAccessScreen = ({denied}: MissingAccessScreenProps) => {
  const {t, i18n} = useTranslation();

  if (!denied) {
    return null;
  }
  return (
    <Stack sx={pageWrapperSx}>
      <LockedImage />
      <Stack
        sx={{
          width: '397px',
        }}
      >
        <Typography sx={{...textSm, marginTop: '16px'}}>
          {t(translations.office.access.denied_message_first)}
          <Link
            target="_blank"
            href={
              denied === 'care_management'
                ? `https://www.sioslife.com/${i18n.language === 'es_ES' ? 'es' : 'pt'}/gestao-e-planeamento-de-cuidados`
                : `https://www.sioslife.com/${i18n.language === 'es_ES' ? 'es' : 'pt'}/inclusao-digital-idosos`
            }
            sx={{...textSm, fontWeight: 500, color: 'var(--dcm-blue-base)'}}
            underline="hover"
          >
            {t(translations.office.access[denied])}
          </Link>
          {t(translations.office.access.denied_message_second)}
        </Typography>

        <Typography
          sx={{
            ...textSm,
            fontWeight: 500,
            marginTop: '16px',
          }}
        >
          {t(translations.office.access.speak)}
        </Typography>
        <Box className="icon" sx={{display: 'flex', marginTop: '14px'}}>
          <MarkunreadOutlined
            fontSize="small"
            sx={{marginRight: '8px', color: 'var(--dcm-blue-base)'}}
          />
          <Link
            target="_blank"
            href="mailto:comunicacao@sioslife.com"
            sx={textLinkSm}
            underline="hover"
          >
            comunicacao@sioslife.com
          </Link>
        </Box>
        <Box className="icon" sx={{display: 'flex', marginTop: '8px'}}>
          <Phone fontSize="small" sx={{marginRight: '8px', color: 'var(--dcm-blue-base)'}} />
          <Typography sx={{...textSm, fontWeight: 500, fontSize: '16px'}}>
            +351 253 676 018
          </Typography>
        </Box>
        <Box className="icon" sx={{display: 'flex', marginTop: '8px'}}>
          <Language fontSize="small" sx={{marginRight: '8px', color: 'var(--dcm-blue-base)'}} />
          <Link target="_blank" href="https://www.sioslife.com" sx={textLinkSm} underline="hover">
            sioslife.com
          </Link>
        </Box>
      </Stack>
    </Stack>
  );
};

export default MissingAccessScreen;
